/*
 * Build-time switches, read from REACT_APP_* variables (frontend/.env, or the shell that runs the
 * dev server or the build). Each is off unless set to "true". Documented in .env.example.
 */

const isOn = (value) => String(value).toLowerCase() === 'true';

/**
 * Shipment Timeline (Stock Management, /shipment-timeline): the menu entry and the page route.
 * Backend twin: SHIPMENT_TIMELINE_ENABLED, without which its API answers 404.
 */
export const shipmentTimelineEnabled = () => isOn(process.env.REACT_APP_SHIPMENT_TIMELINE_ENABLED);
